import React from 'react';

import '../style.css';
import CONF from '../Conf';

export default function AnnouncementCard({ language, body, backgroundColor, fontColor, title }) {
  const bgColor = CONF.color(backgroundColor);
  const fColor = CONF.color(fontColor);
  return (
    <article
      className='Card'
      language={language}
      style={{
        backgroundColor: bgColor,
        color: fColor,
      }}>
      <header>
        <h1
          style={{
            color: fColor,
          }}>
          {title}
        </h1>
      </header>
      <section className='Announcement'>
        <p>{body}</p>
      </section>
      <footer></footer>
    </article>
  );
}
